import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  // Get currency from localStorage or default to '£'
  const [currency, setCurrency] = useState(() => {
    const savedCurrency = localStorage.getItem('selectedCurrency');
    // Validate that the saved currency is one of our supported currencies
    const validCurrencies = ['$', '£', 'AED', 'KSA'];
    return validCurrencies.includes(savedCurrency) ? savedCurrency : '£';
  });

  // Update localStorage whenever currency changes
  const updateCurrency = (newCurrency) => {
    // Validate the currency before saving
    const validCurrencies = ['$', '£', 'AED', 'KSA'];
    if (validCurrencies.includes(newCurrency)) {
      setCurrency(newCurrency);
      localStorage.setItem('selectedCurrency', newCurrency);
    }
  };

  // Ensure currency is loaded from localStorage on mount
  useEffect(() => {
    const savedCurrency = localStorage.getItem('selectedCurrency');
    const validCurrencies = ['$', '£', 'AED', 'KSA'];
    if (savedCurrency && validCurrencies.includes(savedCurrency) && savedCurrency !== currency) {
      setCurrency(savedCurrency);
    } else if (!savedCurrency) {
      // If no saved currency, set to GBP as default
      setCurrency('£');
      localStorage.setItem('selectedCurrency', '£');
    }
    // Force GBP as default for new users or if no currency is set
    if (!savedCurrency) {
      localStorage.setItem('selectedCurrency', '£');
    }
  }, []);

  const value = {
    currency,
    setCurrency: updateCurrency
  };

  return (
    <CurrencyContext.Provider value={value}>
      {children}
    </CurrencyContext.Provider>
  );
}; 